import { useNavigate } from 'react-router-dom';
import { Bar, Icon, TypeBadge, QueryState, ListSkeleton } from '@/components';
import { useCourses, useEnrollments } from '@/hooks/queries';
import { useLocalized } from '@/hooks/useLocalized';

export function DesktopLearning() {
  const navigate = useNavigate();
  const { L } = useLocalized();
  const coursesQuery = useCourses();
  const { data: enrollments = [] } = useEnrollments();
  const enrolled = (coursesQuery.data ?? []).filter((c) => enrollments.some((e) => e.courseId === c.id));

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: 32 }}>
      <h1 style={{ fontSize: 26, fontWeight: 600, letterSpacing: '-.02em', margin: '0 0 22px' }}>My learning</h1>
      <QueryState query={coursesQuery} skeleton={<ListSkeleton rows={3} />} isEmpty={() => enrolled.length === 0} emptyIcon="stack" emptyTitle="You're not enrolled yet" emptyHint="Browse the catalog to start a course." emptyAction={<button className="btn btn-primary btn-sm" onClick={() => navigate('/learn/catalog')}>Browse catalog</button>}>
        {() => (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {enrolled.map((c) => {
          const e = enrollments.find((x) => x.courseId === c.id)!;
          return (
            <button key={c.id} onClick={() => navigate(`/learn/learning/${c.id}`)} style={{ all: 'unset', cursor: 'pointer', display: 'block' }}>
              <div className="card lift" style={{ padding: '4px 16px' }}>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                  <div style={{ width: 80, height: 80, borderRadius: 14, background: c.logoUrl ? `${c.cover} center/contain no-repeat url("${c.logoUrl}")` : c.cover, flex: 'none', border: '1px solid var(--line)' }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div className="th" style={{ fontSize: 16, fontWeight: 600 }}>{L(c.title)}</div>
                      <TypeBadge type={c.type} />
                    </div>
                    <div style={{ fontSize: 13, color: 'var(--ink-3)', margin: '2px 0 4px' }}>{c.title.en} · {c.host}</div>
                    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                      <Bar value={e.progress} style={{ flex: 1 }} />
                      <span className="u-mono" style={{ fontSize: 13, color: 'var(--sage-deep)', fontWeight: 600 }}>{e.progress}%</span>
                    </div>
                  </div>
                  <Icon name="chevR" size={18} style={{ color: 'var(--ink-4)', alignSelf: 'center' }} />
                </div>
              </div>
            </button>
          );
        })}
          </div>
        )}
      </QueryState>
    </div>
  );
}
